import { ELkType } from '../../repositories/lk-type/entities/get_lk_type/GetLkTypeResponseSchema';
import { IApplicationState } from '../../types/redux';

export const selectIsSearcherOrSub = (state: IApplicationState) => state.lkType.type !== ELkType.Specialist;
